<template>
    <div v-if="modelValue" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog"
        aria-modal="true" @click="closePopup">
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
            <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
            <div class="inline-block align-bottom bg-white rounded-[20px] text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-full max-w-6xl" @click.stop>
                <div class="relative w-full max-w-6xl max-h-full bg-white rounded-[30px] z-20">
                    <ContactForm :minimal="true" @close="closePopup" :is-popup="true" />
                </div>
            </div>
        </div>
    </div>

</template>

<script setup>
import ContactForm from './ContactForm.vue'
defineProps({
    modelValue: {
        type: Boolean,
        required: true
    }
});

const emit = defineEmits(['update:modelValue']);

const closePopup = () => {
    emit('update:modelValue', false);
};

</script>
